<template>
  <div
    v-if="visible"
    style="border: 1px solid #b3b3b3; border-radius: 15px; overflow: hidden; margin-bottom: 10px  "
  >
    <div
      style="
        display: flex;
        justify-content: center;
        border-bottom-width: 1px;
        border-bottom-style: solid;
        border-bottom-color: #dfdfdf;
      "
    >
      <div
        style="
          display: flex;
          width: 100%;
          justify-content: center;
          align-items: center;
          font-weight: 600;
          font-size: 18px;
          border-right-width: 1px;
          border-right-style: solid;
          border-right-color: #dfdfdf;
          position: relative;
        "
      >
        <div
          style="
            position: absolute;
            bottom: 0;
            right: 10px;
            z-index: 1;
            padding: 5px;
          "
        >
          <v-tooltip v-if="iconUnselect" top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="!disabled"
                :style="{ cursor: disabled ? 'not-allowed' : 'pointer' }"
                v-bind="attrs"
                v-on="on"
                @click="showUnselectedSearch"
              >
                <svg
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  color="#818181"
                >
                  <path
                    d="M17 17L21 21"
                    stroke="#818181"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M3 11C3 15.4183 6.58172 19 11 19C13.213 19 15.2161 18.1015 16.6644 16.6493C18.1077 15.2022 19 13.2053 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11Z"
                    stroke="#818181"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </div>
            </template>
            <span>{{ $t("labels.searchUnselectedItems") }}</span>
          </v-tooltip>
        </div>
        <div
          style="
            position: absolute;
            bottom: 0;
            left: 10px;
            z-index: 1;
            padding: 5px;
          "
        >
          <v-tooltip v-if="iconUnselect" top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="!disabled"
                style="
                  width: 20px;
                  height: 20px;
                  border: 1px solid #dfdfdf;
                  border-radius: 20%;
                  margin-right: 10px;
                "
                :style="{ cursor: disabled ? 'not-allowed' : 'pointer' }"
                v-bind="attrs"
                v-on="on"
                @click="selectAllUnselected"
              ></div>
            </template>
            <span>{{ $t("titles.checkAll") }}</span>
          </v-tooltip>

          <v-tooltip v-else top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="!disabled"
                style="
                  width: 20px;
                  height: 20px;
                  background-color: #56d49e;
                  border-radius: 20%;
                  margin-right: 10px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
                v-bind="attrs"
                v-on="on"
              >
                <i class="fas fa-check" style="color: white"></i>
              </div>
            </template>
            <span>{{ $t("titles.checkAll") }}</span>
          </v-tooltip>
        </div>
        <div
          style="
            padding: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: 700;
            font-size: 16px;
            color: #1d2e5b;
          "
        >
          {{ $t("labels.tableUnselected") }}
        </div>
      </div>

      <div
        style="
          display: flex;
          width: 100%;
          justify-content: center;
          align-items: center;
          font-weight: 600;
          font-size: 18px;
          position: relative;
        "
      >
        <div
          style="
            position: absolute;
            bottom: 0;
            right: 10px;
            z-index: 1;
            padding: 5px;
          "
        >
          <v-tooltip v-if="iconUnselect" top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="!disabled"
                :style="{ cursor: disabled ? 'not-allowed' : 'pointer' }"
                v-bind="attrs"
                v-on="on"
                @click="showSelectedSearch"
              >
                <svg
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  color="#818181"
                >
                  <path
                    d="M17 17L21 21"
                    stroke="#818181"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M3 11C3 15.4183 6.58172 19 11 19C13.213 19 15.2161 18.1015 16.6644 16.6493C18.1077 15.2022 19 13.2053 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11Z"
                    stroke="#818181"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </div>
            </template>
            <span>{{ $t("labels.searchSelectedItems") }}</span>
          </v-tooltip>
        </div>
        <div
          style="
            position: absolute;
            bottom: 0;
            left: 10px;
            z-index: 1;
            padding: 5px;
          "
        >
          <v-tooltip v-if="iconSelect" top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="!disabled"
                style="
                  width: 20px;
                  height: 20px;
                  border: 1px solid #dfdfdf;
                  border-radius: 20%;
                  margin-right: 10px;
                "
                :style="{ cursor: disabled ? 'not-allowed' : 'pointer' }"
                v-bind="attrs"
                v-on="on"
                @click="unselectAllSelected"
              ></div>
            </template>
            <span>{{ $t("titles.uncheckAll") }}</span>
          </v-tooltip>

          <v-tooltip v-else top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="!disabled"
                style="
                  width: 20px;
                  height: 20px;
                  background-color: #56d49e;
                  border-radius: 20%;
                  margin-right: 10px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
                v-bind="attrs"
                v-on="on"
              >
                <i class="fas fa-check" style="color: white"></i>
              </div>
            </template>
            <span>{{ $t("titles.uncheckAll") }}</span>
          </v-tooltip>
        </div>
        <div
          style="
            display: flex;
            width: 100%;
            justify-content: center;
            align-items: center;
            font-weight: 700;
            font-size: 16px;
            color: #1d2e5b;
          "
        >
          {{ $t("labels.tableSelected") }}
        </div>
      </div>
    </div>

    <div style="display: flex; overflow: hidden">
      <div style="width: 50%; border-right: 1px solid #dfdfdf">
        <div key="searchUnselected" style="border-bottom: 1px solid #dfdfdf">
          <v-text-field
            v-if="searchUnselected"
            v-model="searchUnselectedQuery"
            :placeholder="$t('buttons.search')"
            @input="unselectedSearchDebounce"
            hide-details
            clearable
            solo
            flat
            style="
              color: #818181;
              font-weight: 500;
              max-height: 50px;
              min-height: 50px;
            "
          ></v-text-field>
        </div>

        <div
          style="overflow-y: auto"
          :style="{
            maxHeight: searchSelected && !searchUnselected ? '300px' : '250px',
          }"
        >
          <transition-group
            v-if="filteredLocalUnselectedItems.length > 0"
            name="slide-right"
            tag="div"
          >
            <div
              v-for="(item, index) in filteredLocalUnselectedItems"
              v-if="!item.checked"
              :key="item.Id || item"
              :style="{
                borderBottom:
                  index !== localUnselectedItems.length - 1 ||
                  localUnselectedItems.length < 5
                    ? '1px solid #dfdfdf'
                    : 'none',
                cursor: disabled ? 'not-allowed' : 'pointer',
              }"
              style="
                padding: 15px;
                display: flex;
                align-items: center;
                max-height: 50px;
                min-height: 50px;
              "
              @click="!disabled ? moveToChecked(item) : null"
            >
              <div
                v-if="!disabled"
                style="
                  width: 20px;
                  height: 20px;
                  border: 1px solid #dfdfdf;
                  border-radius: 20%;
                  margin-right: 10px;
                "
              ></div>
              <span>{{ item.Name || item.CompanyName || item.GroupName }}</span>
            </div>
          </transition-group>
          <div
            v-else
            class="d-flex justify-center items-center text-center py-4"
          >
            <p style="margin: 0; padding: 0">
              {{ $t("messages.noData") }}
            </p>
          </div>
        </div>
      </div>
      <div style="width: 50%">
        <div key="searchSelected" style="border-bottom: 1px solid #dfdfdf">
          <v-text-field
            v-if="searchSelected"
            v-model="searchSelectedQuery"
            :placeholder="$t('buttons.search')"
            @input="selectedSearchDebounce"
            hide-details
            clearable
            solo
            flat
            style="
              color: #818181;
              font-weight: 500;
              max-height: 50px;
              min-height: 50px;
            "
          ></v-text-field>
        </div>
        <div
          style="overflow-y: auto"
          :style="{
            maxHeight: !searchSelected && searchUnselected ? '300px' : '250px',
          }"
        >
          <transition-group
            v-if="filteredLocalSelectedItems.length > 0"
            name="slide-left"
            tag="div"
          >
            <div
              v-for="(item, index) in filteredLocalSelectedItems"
              :key="item.Id || item"
              v-if="item.checked"
              :style="{
                borderBottom:
                  index !== localSelectedItems.length - 1 ||
                  localSelectedItems.length < 5
                    ? '1px solid #dfdfdf'
                    : 'none',
                cursor: disabled ? 'not-allowed' : 'pointer',
              }"
              style="
                padding: 15px;
                display: flex;
                align-items: center;
                max-height: 50px;
                min-height: 50px;
              "
              @click="!disabled ? moveToUnchecked(item) : null"
            >
              <div
                v-if="!disabled"
                style="
                  width: 20px;
                  height: 20px;
                  background-color: #56d49e;
                  border-radius: 20%;
                  margin-right: 10px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <i class="fas fa-check" style="color: white"></i>
              </div>
              <span>{{ item.Name || item.CompanyName || item.GroupName }}</span>
            </div>
          </transition-group>
          <div
            v-else
            class="d-flex justify-center items-center text-center py-4"
          >
            <p style="margin: 0; padding: 0">
              {{ $t("messages.noData") }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    unselectedItems: {
      type: Array,
      required: true,
    },
    selectedItems: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      localSelectedItems: [],
      localUnselectedItems: [],
      iconSelect: true,
      iconUnselect: true,
      searchSelected: false,
      searchUnselected: false,
      searchUnselectedQuery: "",
      searchSelectedQuery: "",
      searchTimeout: null,
      isUpdating: false,
    };
  },

  computed: {
    filteredLocalSelectedItems: {
      get() {
        return this.searchItems(
          this.localSelectedItems,
          this.searchSelectedQuery
        );
      },
      set(newSelectedItems) {
        // Prevent recursive updates by checking the flag
        if (!this.isUpdating) {
          this.isUpdating = true;
          this.localSelectedItems = newSelectedItems;
          this.updateSelectedItems();
          this.isUpdating = false;
        }
      },
    },
    filteredLocalUnselectedItems: {
      get() {
        return this.searchItems(
          this.localUnselectedItems,
          this.searchUnselectedQuery
        );
      },
      set(newUnselectedItems) {
        // Prevent recursive updates by checking the flag
        if (!this.isUpdating) {
          this.isUpdating = true;
          this.localUnselectedItems = newUnselectedItems;
          this.updateSelectedItems();
          this.isUpdating = false;
        }
      },
    },
  },

  watch: {
    unselectedItems: {
      immediate: true,
      handler() {
        this.reinitializeItems();
      },
    },
    selectedItems: {
      immediate: true,
      handler() {
        this.reinitializeItems();
      },
    },
  },

  methods: {
    showUnselectedSearch() {
      if (this.searchUnselected) {
        this.searchUnselectedQuery = "";
      }
      this.searchUnselected = !this.searchUnselected;
      this.debounceSearch();
    },
    showSelectedSearch() {
      console.log("show >> ", this.searchSelected);
      if (this.searchSelected) {
        this.searchSelectedQuery = "";
      }

      this.searchSelected = !this.searchSelected;
      this.debounceSearch();
    },

    unselectedSearchDebounce() {
      this.debounceSearch("unselected");
    },
    selectedSearchDebounce() {
      this.debounceSearch("selected");
    },
    searchItems(items, query) {
      if (!query) return items;
      const queryLower = query.toLowerCase();
      return items.filter((item) => {
        const name = item.Name || item.CompanyName;
        return name ? name.toLowerCase().includes(queryLower) : false;
      });
    },

    debounceSearch(queryType) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.$forceUpdate(); // Forces re-render after debounce
      }, 500);
    },

    showSearch(queryType) {
      if (queryType === "selected") {
        this.searchSelected = !this.searchSelected;
      } else {
        this.searchUnselected = !this.searchUnselected;
      }
      this.debounceSearch();
    },

    reinitializeItems() {
      const selectedItemsSet = new Set(this.selectedItems);
      this.localSelectedItems = this.unselectedItems
        .filter(
          (item) => selectedItemsSet.has(item.Id) || selectedItemsSet.has(item)
        )
        .map((item) => ({ ...item, checked: true }));

      this.localUnselectedItems = this.unselectedItems
        .filter(
          (item) =>
            !selectedItemsSet.has(item.Id) && !selectedItemsSet.has(item)
        )
        .map((item) => ({ ...item, checked: false }));

      // Re-assign filtered lists after reinitialization
      this.filteredLocalSelectedItems = this.localSelectedItems;
      this.filteredLocalUnselectedItems = this.localUnselectedItems;

      this.$forceUpdate();
    },

    moveToChecked(item) {
      this.localUnselectedItems = this.localUnselectedItems.filter(
        (i) => i.Id !== item.Id
      );
      item.checked = true;
      this.localSelectedItems.push(item);
      this.updateSelectedItems();
    },

    moveToUnchecked(item) {
      this.localSelectedItems = this.localSelectedItems.filter(
        (i) => i.Id !== item.Id
      );
      item.checked = false;
      this.localUnselectedItems.push(item);
      this.updateSelectedItems();
    },

    updateSelectedItems() {
      if (!this.isUpdating) {
        this.isUpdating = true;
        this.$emit(
          "input",
          this.localSelectedItems.map((item) => item.Id)
        );
        this.debounceSearch();
        this.isUpdating = false;
      }
    },

    selectAllUnselected() {
      this.iconUnselect = !this.iconUnselect;
      setTimeout(() => {
        this.iconUnselect = !this.iconUnselect;
      }, 500);

      this.localUnselectedItems.forEach((item) => {
        if (!item.checked) {
          item.checked = true;
          this.localSelectedItems.push(item);
        }
      });
      this.localUnselectedItems = [];
      this.updateSelectedItems();
    },

    unselectAllSelected() {
      this.iconSelect = !this.iconSelect;
      setTimeout(() => {
        this.iconSelect = !this.iconSelect;
      }, 500);

      this.localSelectedItems.forEach((item) => {
        if (item.checked) {
          item.checked = false;
          this.localUnselectedItems.push(item);
        }
      });
      this.localSelectedItems = [];
      this.updateSelectedItems();
    },
  },
};
</script>

<style scoped>
.slide-left-enter-active,
.slide-left-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease;
}
.slide-left-enter-from {
  transform: translateX(-100%);
  opacity: 1;
}
.slide-left-leave-to {
  transform: translateX(-100%);
  opacity: 1;
}

.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease;
}
.slide-right-enter-from {
  transform: translateX(100%);
  opacity: 1;
}
.slide-right-leave-to {
  transform: translateX(100%);
  opacity: 1;
}

@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css");
.v-input__slot::before {
  border-style: none !important;
}
</style>
